// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7457314c","455":"23c5bcc8","488":"d708548e"}[chunkId] + ".chunk.js";
};